<template>
  <div>
    <vue-headful />
    <Header
      menuClass="invisible"
      :link="{ name: 'applicant-step_3', params: { action: 'save' } }"
    />
    <div class="px-4 mx-2 pb-4">
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <div class="container-fluid px-0 pb-1 mb-2">
          <NotificationContainer />
          <div>
            <p class>
              <strong>Omschrijving opleiding</strong>
            </p>
            <div class="form-group w-square-icon">
              <select
                class="custom-select"
                v-bind:class="[
                  this.required.includes('degree_id') && !form.degree_id
                    ? 'require'
                    : ''
                ]"
                v-model="form.degree_id"
                required
              >
                <option value selected disabled>Opleiding</option>
                <option
                  v-for="degree in this.degreesList"
                  :key="degree.id"
                  :value="degree.id"
                  >{{ degree.title }}</option
                >
              </select>
              <div
                class="icon-wrapper dropdown position-absolute align-self-center border-left"
              >
                <svg-icon icon="chevron_s" />
              </div>
            </div>
            <div class="form-group w-square-icon">
              <select
                class="custom-select"
                v-bind:class="[
                  this.required.includes('university_id') && !form.university_id
                    ? 'require'
                    : ''
                ]"
                v-model="form.university_id"
                required
              >
                <option value selected disabled>Naam school</option>
                <option
                  v-for="university in this.universitiesList"
                  :key="university.id"
                  :value="university.id"
                  >{{ university.name }}</option
                >
              </select>
              <div
                class="icon-wrapper dropdown position-absolute align-self-center border-left"
              >
                <svg-icon icon="chevron_s" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6 pr-2">
                <div>
                  <div class="form-group w-square-icon">
                    <input
                      type="text"
                      class="form-control calendar"
                      v-bind:class="[
                        this.required.includes('start_date') ? 'require' : ''
                      ]"
                      placeholder="Begin datum"
                      v-model="display_startDate"
                      required
                    />
                    <div
                      class="icon-wrapper calendar position-absolute align-self-center border-left"
                      v-on:click="fakeDatePicker('start')"
                    >
                      <i class="material-icons-round">calendar_today</i>
                    </div>
                    <div
                      class="syncfusion-calendar fake-datepicker"
                      v-show="this.calendar.show_start"
                    >
                      <div class="icon-wrapper arrow-back">
                        <i class="material-icons-round">arrow_back</i>
                      </div>
                      <div class="icon-wrapper arrow-forward">
                        <i class="material-icons-round">arrow_forward</i>
                      </div>
                      <ejs-calendar
                        :value="calendar.start_date"
                        :start="calendar.start"
                        :depth="calendar.depth"
                        :created="onStartChange"
                        :change="onStartChange"
                        :max="calendar.max_date"
                        :isMultiSelection="false"
                        :firstDayOfWeek="calendar.week"
                      ></ejs-calendar>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 pl-2">
                <div class="form-group w-square-icon">
                  <input
                    type="text"
                    class="form-control calendar"
                    v-bind:class="[
                      this.required.includes('end_date') ? 'require' : ''
                    ]"
                    placeholder="Eind datum"
                    v-model="display_endDate"
                    required
                  />
                  <div
                    class="icon-wrapper calendar position-absolute align-self-center border-left"
                    v-on:click="fakeDatePicker('end')"
                  >
                    <i class="material-icons-round">calendar_today</i>
                  </div>
                  <div
                    class="syncfusion-calendar fake-datepicker right"
                    v-show="this.calendar.show_end"
                  >
                    <div class="icon-wrapper arrow-back">
                      <i class="material-icons-round">arrow_back</i>
                    </div>
                    <div class="icon-wrapper arrow-forward">
                      <i class="material-icons-round">arrow_forward</i>
                    </div>
                    <ejs-calendar
                      :value="calendar.end_date"
                      :start="calendar.start"
                      :depth="calendar.depth"
                      :created="onEndChange"
                      :change="onEndChange"
                      :max="calendar.max_date"
                      :isMultiSelection="false"
                      :firstDayOfWeek="calendar.week"
                    ></ejs-calendar>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group pt-2 mb-4 pb-2">
            <textarea
              class="form-control"
              placeholder="Heb je extra vakken of een specialisatie gevolgd? Vertel het hier."
              rows="5"
              v-model="form.description"
            ></textarea>
          </div>
          <button
            v-if="!this.id"
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Voeg opleiding toe
          </button>
          <button
            v-if="this.id"
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Opslaan
          </button>
          <button
            v-if="this.id"
            @click="deleteEducation"
            type="button"
            class="btn btn-gray btn-block"
            v-ripple="'rgba(145, 139, 136, 0.1)'"
          >
            Verwijder
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      degreesList: [],
      universitiesList: [],
      display_startDate: "",
      display_endDate: "",
      form: {
        id: this.id,
        degree_id: "",
        university_id: "",
        start_date: "",
        end_date: "",
        description: ""
      },
      required: ["degree_id", "university_id", "start_date", "end_date"],
      calendar: {
        start_date: this.formatNoTime(),
        end_date: this.formatNoTime(),
        max_date: null,
        start: "Year",
        depth: "Year",
        show_start: false,
        show_end: false,
        week: 1
      }
    };
  },
  props: ["id"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.universitiesList = await this.getAPIList("universities");
      this.degreesList = await this.getAPIList("degrees");
      await this.autoFillForm();
      this.$forceUpdate();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        if (this.id) {
          const ID = parseInt(this.id);
          const user = JSON.parse(localStorage.getItem("user"));
          const educations = user.educations;
          var education = educations.find(obj => obj.id === ID);
          for (var key in this.form) {
            if (education[key]) {
              this.form[key] = education[key]; // update
            }
          }
          this.calendar.start_date = this.formatNoTime(this.form.start_date);
          this.calendar.end_date = this.formatNoTime(this.form.end_date);

          this.display_startDate = this.formatMMYYYY(this.form.start_date);
          this.display_endDate = this.formatMMYYYY(this.form.end_date);
        }
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          year = d.getFullYear();
        var last_day = new Date(year, month + 1, 0).getDate();
        this.calendar.max_date = [year, month, last_day].join("-");
        resolve();
      });
    },
    async onStartChange(args) {
      if (args && args.value) {
        if (args.value) {
          const new_date = this.formatDate(args.value, "start");
          this.calendar.start_date = this.formatNoTime(new_date);
          this.form.start_date = new_date;
          this.display_startDate = this.formatMMYYYY(args.value);
        }
        await this.compareDates("start");
        if (args.event) {
          if (args.event.type == "click") {
            localStorage.setItem("form-pending", JSON.stringify(true));
          }
        }
        this.calendar.show_start = false;
      }
    },
    async onEndChange(args) {
      if (args && args.value) {
        if (args.value) {
          const new_date = this.formatDate(args.value, "end");
          this.calendar.end_date = this.formatNoTime(new_date);
          this.form.end_date = new_date;
          this.display_endDate = this.formatMMYYYY(args.value);
        }
        await this.compareDates("end");
        if (args.event) {
          if (args.event.type == "click") {
            localStorage.setItem("form-pending", JSON.stringify(true));
          }
        }
        this.calendar.show_end = false;
      }
    },
    async saveEducation() {
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;

        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }

        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/education";
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(success => {
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: success.data.message
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(error => {
            const notification = {
              type: "danger",
              message: error.response.data
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async deleteEducation() {
      const ID = parseInt(this.id);
      await this.deleteRecord("/education/" + ID);
      // continue only if resolve()
      await this.updateLocalUser();
      await this.redirectBack();
    },
    async onSubmit() {
      window.scrollTo(0, 0);
      await this.saveEducation();
      // continue only if resolve()
      await this.updateLocalUser();
      await this.redirectBack();
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(
          () =>
            this.$router.replace({
              name: "applicant-step_3",
              params: { action: "save" }
            }),
          800
        );
      });
    },
    fakeDatePicker(target) {
      if (target == "start") {
        this.calendar.show_end = false;
        this.calendar.show_start = this.calendar.show_start ? false : true;
      } else if (target == "end") {
        this.calendar.show_start = false;
        this.calendar.show_end = this.calendar.show_end ? false : true;
      }
    },
    compareDates(target) {
      return new Promise(resolve => {
        var startDate = this.form.start_date;
        var endDate = this.form.end_date;
        if (startDate && endDate) {
          if (Date.parse(startDate) > Date.parse(endDate)) {
            // reset date
            if (target === "start") {
              this.display_startDate = "";
              this.form.start_date = "";
              this.calendar.start_date = null;
            } else if (target === "end") {
              this.display_endDate = "";
              this.form.end_date = "";
              this.calendar.end_date = null;
            }
          }
        }
        resolve();
      });
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    }
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped></style>
